import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';
import { News } from '@games/entities';
import { INews } from '@games/interfaces';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  constructor(private http: HttpClient) {}

  getNewses(
    courseId: number,
    gameId: number,
    filters: HttpParams | { [params: string]: string | string[] } = {},
    isSilentLoader = false
  ) {
    return this.http
      .get<any>(`${environment.apiUrl}courses/${courseId}/games/${gameId}/news/`, {
        params: filters,
        headers: { 'silent-loader': isSilentLoader ? 'true' : 'false' },
      })
      .pipe(map(res => ({ ...res, results: res.results.map((news: INews) => new News(news)) })));
  }

  createNews(courseId: number, gameId: number, newsConfig: any) {
    return this.http.post<any>(
      `${environment.apiUrl}courses/${courseId}/games/${gameId}/news/`,
      newsConfig
    );
  }

  updateNews(courseId: number, gameId: number, id: number, newsConfig: any) {
    return this.http
      .patch<any>(
        `${environment.apiUrl}courses/${courseId}/games/${gameId}/news/${id}/`,
        newsConfig
      )
      .pipe(map((news: INews) => new News(news)));
  }

  deleteNews(courseId: number, gameId: number, id: number) {
    return this.http.delete<any>(
      `${environment.apiUrl}courses/${courseId}/games/${gameId}/news/${id}/`,
      { observe: 'response' }
    );
  }
}
